<div class="qr-code-dialog">
  <div class="qr-code-dialog__title-container">
    <span class="qr-code-dialog__title">
      {{ 'TRANS__QR_CODE_DIALOG__CODE_FOR' | translate }} {{ artifactName }}
    </span>
  </div>

  <div class="qr-code-dialog__content">
    <div class="qr-code-dialog__settings">
      <div class="qr-code-dialog__display-settings">
        <span class="qr-code-dialog__display">
          {{ 'TRANS__QR_CODE_DIALOG__DISPLAY_OPTIONS' | translate }}
        </span>

        <div class="qr-code-dialog__display-options">
          @for (option of extraDataOptions(); track $index) {
            <mat-checkbox
              (change)="optionChecked(option)"
            >
              {{ option.label | translate }}
            </mat-checkbox>
          }
        </div>
      </div>
    </div>

    <div class="qr-code-dialog__preview">
      <app-object-page-qr-code
        [artifactIds]="[artifactId]"
        [displayExtraData]="displayExtraData()"
      />
    </div>
  </div>

  <div class="qr-code-dialog__footer">
    <button
      mat-flat-button
      (click)="togglePrintWindow()"
    >
      {{ 'TRANS__QR_CODE_DIALOG__PRINT' | translate}}
    </button>

    <button
      mat-button
      (click)="cancelPrintDialog()"
    >
      {{ 'TRANS__QR_CODE_DIALOG__CANCEL' | translate }}
    </button>
  </div>
</div>
